/* Kiwi remains the measurement source. Enhance only explicitly flat-measured pants charts. */
(function () {
  'use strict';
  function closestSizes(value, entries) {
    if (!Number.isFinite(value) || value <= 0 || !entries.length || entries.some(function (e) { return !Number.isFinite(e.width); })) return [];
    var widths = entries.map(function (e) { return e.width; });
    if (value < Math.min.apply(null, widths) || value > Math.max.apply(null, widths)) return [];
    var distance = Math.min.apply(null, widths.map(function (n) { return Math.abs(n - value); }));
    return entries.filter(function (e) { return Math.abs(Math.abs(e.width - value) - distance) < 0.001; });
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = closestSizes; return; }
  if (window.sqPantsSizeHelpLoaded) return;
  window.sqPantsSizeHelpLoaded = true;

  function enhance() {
    document.querySelectorAll('.kiwi-sizing-modal .ks-chart-individual').forEach(function (chart) {
      // Do not infer flat vs circumference from a number; require the maintained chart's own explanation.
      if (!chart.textContent.includes('All widths are measured with the pants laid flat')) return;
      var table = chart.querySelector('.ks-table');
      if (!table || table.dataset.sqSizeHelp) return;
      var rows = Array.from(table.rows);
      var waist = rows.find(function (r) { return r.cells[0].textContent.trim() === 'Waist'; });
      var length = rows.find(function (r) { return r.cells[0].textContent.trim() === 'Length'; });
      if (!waist || !length) return;
      var entries;
      try {
        entries = Array.from(waist.cells).slice(1).map(function (cell, i) {
          var values = JSON.parse(cell.dataset.unitValues);
          return { size: rows[0].cells[i + 1].textContent.trim(), width: Number(values['0']), cm: Number(values['1']), col: i + 1 };
        });
      } catch (_) { return; }
      if (!entries.length || entries.some(function (e) { return !Number.isFinite(e.width) || !Number.isFinite(e.cm); })) return;
      table.dataset.sqSizeHelp = 'true';
      chart.classList.add('sq-pants-chart');
      waist.cells[0].textContent = 'Waist width';
      length.cells[0].textContent = 'Length (outseam)';
      chart.querySelectorAll('p').forEach(function (p) {
        if (p.textContent.trim() === 'Between sizes, take the larger. Linen does not stretch.') p.textContent = 'Compare the waist, hip and length with pants that fit you well.';
      });
      var intro = document.createElement('p');
      intro.className = 'sq-size-intro';
      intro.textContent = 'Garment measurements, laid flat. Compare with pants you own. Waist width—not body circumference. Length = waistband to hem.';
      var wrap = chart.querySelector('.ks-table-content-wrapper');
      wrap.insertBefore(intro, wrap.firstChild);
      var box = document.createElement('div');
      box.className = 'sq-size-match';
      box.innerHTML = '<label>Your pants’ waist width, laid flat<input type="number" inputmode="decimal" min="0" step="any" placeholder="e.g. 17" aria-label="Your pants waist width"></label><div class="sq-size-match__row"><select aria-label="Waist measurement unit"><option value="in">Inches</option><option value="cm">Centimeters</option></select><button type="button">Find closest size</button></div><p class="sq-size-match__result" role="status" aria-live="polite"></p>';
      wrap.insertBefore(box, intro.nextSibling);
      var input = box.querySelector('input'), unit = box.querySelector('select'), result = box.querySelector('[role="status"]');
      function clear() {
        result.textContent = '';
        table.querySelectorAll('.sq-size-match-cell').forEach(function (c) { c.classList.remove('sq-size-match-cell'); });
      }
      function match() {
        clear();
        var value = Number(input.value);
        if (!input.value || !Number.isFinite(value) || value <= 0) { result.textContent = 'Enter the width across your fastened waistband, laid flat.'; return; }
        var choices = closestSizes(value, entries.map(function (e) { return { size: e.size, width: unit.value === 'cm' ? e.cm : e.width, col: e.col }; }));
        if (!choices.length) { result.textContent = 'That measurement is outside this chart. Contact us for help choosing a size.'; return; }
        result.textContent = (choices.length === 1 ? 'Closest waist match: size ' : 'Between sizes ') + choices.map(function (e) { return e.size; }).join(' and ') + '. Check the hip and length below, too.';
        choices.forEach(function (e) { rows.forEach(function (r) { if (r.cells[e.col]) r.cells[e.col].classList.add('sq-size-match-cell'); }); });
      }
      box.querySelector('button').addEventListener('click', match);
      input.addEventListener('input', clear);
      input.addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); match(); } });
      unit.addEventListener('change', function () { input.value = ''; input.placeholder = unit.value === 'cm' ? 'e.g. 43.2' : 'e.g. 17'; clear(); });
      var help = document.createElement('a');
      help.href = '/pages/contact-us'; help.textContent = 'Need help choosing? Contact us'; help.className = 'sq-size-contact';
      box.appendChild(help);
    });
  }
  // Kiwi injects its modal asynchronously. Observe insertions, not every attribute or keystroke.
  var queued = false;
  new MutationObserver(function (records) {
    if (queued || !records.some(function (r) { return Array.from(r.addedNodes).some(function (n) { return n.nodeType === 1 && (n.matches('.kiwi-sizing-modal, .ks-chart-individual, .ks-table') || n.querySelector('.ks-table')); }); })) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; enhance(); });
  }).observe(document.body, { childList: true, subtree: true });
  enhance();
})();
